'use strict';

class MonkeypoxSubscriptionApi {
    constructor(DoclrHttp) {
        'ngInject';

        this.DoclrHttp = DoclrHttp;
    }

    subscribe(slug, person) {
        return this.DoclrHttp.post('/api/public/'+slug+'/subscribe', person);
    }


}

(function () {
    angular.module('doclr.monkeypoxsubscription')
        .service('MonkeypoxSubscriptionApi', MonkeypoxSubscriptionApi);
})();
